// AuthentiChain-Frontend/src/components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import { jwtDecode } from "jwt-decode";

export function ProtectedRoute({ children }) {
  const { token } = React.useContext(AuthContext);

  if (token) {
    try {
      const { exp } = jwtDecode(token);
      if (Date.now() >= exp * 1000) throw new Error("Token expired");
      return children;
    } catch (err) {
      return <Navigate to="/login" />;
    }
  }

  return <Navigate to="/login" />;
}
